export const en = {
  common: {
    myTrips: 'My Trips',
    settings: 'Settings',
    signIn: 'Sign In',
    signOut: 'Sign out',
    signedIn: 'Signed in',
    account: 'Account',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    back: 'Back',
    close: 'Close',
    copy: 'Copy',
    share: 'Share',
    view: 'View',
    navigate: 'Navigate',
    copiedToClipboard: 'Copied to clipboard!',
    explore: 'Explore',
    showMore: 'Show more',
    showLess: 'Show less',
    coachInstantSave: 'Tap to instantly save this place to your trip',
    updateAvailableTitle: 'New version available',
    updateAvailableBody: 'Refresh to load the latest version of TripBoom. Your unsaved changes may be lost.',
    refresh: 'Refresh',
  },

  input: {
    interestedIn: 'Interested in..',
    tagline: 'Any location, your time, your way.',
    whereAreYou: 'Where are you?',
    locationPlaceholder: 'City or neighbourhood...',
    pleaseEnterLocation: 'Please enter a location',
    useMyCurrentLocation: 'Use my current location',
    locationErrorRetry: 'Try again',
    locationErrorEnterManually: 'Or enter it manually',
    howLong: 'How long do you have?',
    howGettingAround: 'How are you getting around?',
    imFeeling: "I'm feeling...",
    pleaseSelectVibe: 'Please select at least one vibe',
    findMyAdventure: 'Find my adventure',
    placesFiltered: '{count} place{s} filtered - not open now',
    includeClosedPlaces: 'Include closed places',
  },

  share: {
    title: 'Share TripBoom',
    message: 'This app planned my whole day out in 10 seconds \u2014 restaurants, bars, things to do. Try it \uD83D\uDC47',
    copyLink: 'Copy link',
    copied: 'Copied!',
    shareOn: 'Share on',
    twitter: 'X',
    facebook: 'Facebook',
    linkedin: 'LinkedIn',
    email: 'Email',
    // H-218 Settings tap-to-share + Share Now CTA
    shareWithFriendTitle: 'Share with a friend',
    earnSubtitle: 'Earn +2 Interest & +2 AI High searches when they sign up — or have your friend scan the QR.',
    scanSubtitle: 'Scan to open TripBoom on another device',
    shareNow: 'Share Now',
    shareViaQrAria: 'Tap to share TripBoom',
    shareMessage: 'Try TripBoom — your AI travel concierge. Use my link or scan the QR: {url}',
  },

  time: {
    '1-2-hrs': '1-2 hrs',
    'half-day': 'Half day',
    'full-day': 'Full day',
    '2-3-days': '2-3 days',
  },

  transport: {
    walking: 'Walking',
    transit: 'Public',
    taxi: 'Taxi/Car',
  },

  vibes: {
    hungry: 'Hungry',
    adventurous: 'Adventurous',
    'must-sees': 'Must-See',
    'feeling-lucky': 'Feeling Lucky',
    popular: 'Popular',
    'hidden-gems': 'Hidden Gem',
  },

  travel: {
    nearby: 'Nearby',
    rightHere: 'Right here',
    minWalk: '{n} min walk',
    minTransit: '~{n} min by transit',
    minDrive: '~{n} min drive',
    mins: '{n} mins',
    hrMins: '{h} hr {m} mins',
    localSpot: 'Local spot',
  },

  results: {
    placesFound: '{count} recommendations',
    findMorePlaces: 'Find more places',
    searchingWiderArea: 'Searching wider area...',
    placesSelected: '{count} place{s} selected',
    saveTrip: 'Save Trip',
    viewTrip: 'View Trip',
    saving: 'Saving...',
    saved: 'Saved',
    iWannaGo: 'I wanna go!',
    address: 'Address',
    hoursToday: 'Hours today',
    visitWebsite: 'Visit website',
    copyHookLabel: 'Notes',
    copyTravelLabel: 'Travel',
    copyMapsLabel: 'Google Maps',
    showingFiltered: 'Showing {filtered} of {total}',
    showingAll: 'Showing All',
    offlineRankingBanner: 'AI unavailable — ranked by rating, distance and opening hours.',
  },

  loadingStages: {
    checkingLocation: 'Checking out location',
    checkingLocationNamed: 'Checking out {name}',
    discoveringPlaces: 'Discovering places',
    searchesComplete: '{completed}/{total} searches complete',
    searchingCustomVibe: 'Searching custom vibe...',
    mergingResults: 'Merging results...',
    deepSearching: 'Deep searching for hidden gems',
    findingMore: 'Finding more options',
    sortingByRating: 'Sorting by rating and distance',
    aiMatchingVibes: 'AI matching vibes',
    aiAnalysing: 'AI analysing your options',
    sendingToAi: 'Sending to AI...',
    processingResponse: 'Processing response...',
    filteringResults: 'Filtering results...',
    analysedEliminated: 'Analysed {analysed}, eliminated {eliminated}',
  },

  poi: {
    moreLikeThis: 'More like this',
    lessLikeThis: 'Less like this',
    moreLikeThisConfirm: 'More like this',
    lessLikeThisConfirm: 'Less like this',
    cleared: 'Cleared',
    open: 'Open',
    closed: 'Closed',
    likelyOpen: 'Likely open',
    likelyClosed: 'Likely closed',
    easy: 'Easy',
    doable: 'Doable',
    far: 'Far',
    travelTimeEstimate: 'Rough estimate based on distance — actual travel time may vary',
    travelTimeGoogle: 'Travel time from Google Maps',
    foundOnTripBoom: 'Found on TripBoom, your AI travel concierge — tripboom.app',
  },

  cancel: {
    takingABreak: 'Taking a break?',
    pauseDescription: 'Pause instead of cancelling — your taste profile and saved trips stay safe.',
    proActiveUntil: 'Pro stays active until {date}',
    pauseMonths: 'Pause {count} month',
    pauseMonthsPlural: 'Pause {count} months',
    resumesOn: 'Resumes {date}',
    resumeAnytime: 'Resume anytime',
    pauseIndefinitely: 'Pause indefinitely',
    resumeWhenReady: 'Resume when ready',
    resumeFromSettings: 'You can resume anytime from Settings. Your data is always kept.',
    cancelInstead: 'Cancel subscription instead',
    confirmTitle: 'Cancel Pro?',
    confirmBody: 'You keep Pro until {date}, then your account goes back to the free plan. Saved trips and your taste profile stay.',
    confirmBodyNoDate: 'Your account goes back to the free plan. Saved trips and your taste profile stay.',
    keepPro: 'Keep Pro',
    confirmCancel: 'Cancel Pro',
  },

  installBanner: {
    addToHomeScreen: 'Add to Home Screen',
    fileToDock: 'Add to Dock',
    bestExperience: 'best experience',
    install: 'Install',
    dismiss: 'Dismiss',
  },

  loading: {
    messages: [
      'Searching nearby...',
      'Checking opening hours...',
      'Filtering by distance...',
      'Checking ratings...',
      'Finding hidden gems...',
      'Matching your vibes...',
      'Ranking results...',
      'Asking the locals...',
      'Filtering tourist traps...',
      'Finding the good stuff...',
      'Almost there...',
    ],
  },

  settings: {
    title: 'Settings',
    aiMode: 'AI Support',
    aiModeDescription: 'Use AI to prioritise, enrich and describe your results',
    aiOffNotice: 'AI is disabled. Results will be sorted by star rating and distance. Descriptions will use Google data only.',
    aiLevelPrompt: 'Choose your AI support level:',
    aiLevels: {
      off: 'Off',
      low: 'Low',
      medium: 'Medium',
      high: 'High',
    },
    aiLevelDescriptions: {
      low: 'Quick vibe matching, basic ranking',
      medium: 'Travel times, practicality scores',
      high: 'Wider search, deeper taste matching',
    },
    showOnlyOpenPlaces: 'Show only open places',
    filterClosedPlaces: 'Filter out closed places during short time slots',
    minimumStarRating: 'Minimum star rating',
    onlyShowRatingOrHigher: 'Only show places with this rating or higher',
    any: 'Any',
    searchDistance: 'Search Distance',
    adjustSearchDistance: 'Adjust how far to search for each transport and time combination.',
    placeCategories: 'Place Categories',
    categoriesUsedWhenAIFails: 'Categories are used when AI fails to classify.',
    settingsSessionOnly: 'Your filters last for this session only and reset on refresh. Sign in to keep them.',
    settingsSavedLoggedIn: 'Settings are only saved for logged-in users.',
    signInToSave: 'Sign in to save your trips',
    installApp: 'Install App',
    installAppDescription: 'Add TripBoom to your home screen for quick access',
    install: 'Install',
    tripGrouping: 'Group Trips By',
    tripGroupingDescription: 'Choose how to organize your saved trips',
    groupByDay: 'Day',
    groupByLocation: 'Location',
    filters: 'Filters',
    upgradeToPremium: 'Get Pro',
    unlimitedTripsDescription: 'Unlimited saves, searches & AI High mode',
    upgrade: 'Upgrade',
    premiumMember: 'Pro Member',
    lifetimeAccess: 'Lifetime access to unlimited features & saves',
    yearlyAccess: 'Yearly access to unlimited features & saves',
    tripPassAccess: 'Trip Pass — active',
    appearance: 'Appearance',
    theme: 'Theme',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeSystem: 'System',
    tasteProfile: 'Taste Map',
    interactions: 'interactions',
    tripsPlanned: 'trips planned',
    topCategories: 'Top categories',
    topVibes: 'Top vibes',
    tasteImproves: 'Your recommendations improve with every interaction',
    topInterests: 'Top interests',
    travelStyle: 'Travel style',
    prefersNearby: 'Prefers nearby',
    prefersExploring: 'Loves exploring far',
    mixedExplorer: 'Mixed explorer',
    prefersMixed: 'Mixed explorer',
    subscribe: 'Subscribe',
    premiumAccess: 'Subscribe to Pro',
    premiumSupporter: 'Pro Member',
    monthlyAccess: 'Monthly access to unlimited features & saves',
    getProCTA: 'Get Pro — Unlimited Trips and Credits',
    yourBenefits: 'Your benefits',
    yourCredits: 'Your credits',
    freeCredits: 'Your free credits',
    freeCreditsOnReg: 'Your free credits — on registration',
    dayGroups: 'Day Groups',
    locationGroups: 'Location Groups',
    interestSearches: 'Interest Searches',
    highAiSearches: 'AI High searches',
    unlimited: 'Unlimited',
    perMonth: '/month',
    unlimitedInterestSearches: 'Unlimited interest searches',
    unlimitedInterestSearchesFull: 'Unlimited "Interested in..." searches',
    savedInterestsBenefit: 'Saved Interests — personalise every search',
    unlimitedGroups: 'Unlimited day/location groups',
    unlockArchived: 'Unlock Time Archived Trips',
    feedbackViaWebsite: 'Feedback via Website ↗',
    privacyAndData: 'Privacy & data ↗',
    contactSupport: "Contact support",
    deleteAccount: "Delete my account",
    deleteAccountTitle: "Delete your account?",
    deleteAccountBody: "This permanently deletes your account, saved trips, shared links, taste profile and credits. It can't be undone.",
    deleteAccountCancel: "Keep my account",
    deleteAccountConfirm: "Delete permanently",
    deleteAccountDeleting: "Deleting…",
    deleteAccountDone: "Your account and data have been deleted.",
    deleteAccountFailed: "We couldn't delete your account just now. Please try again, or email support@tripboom.app.",
    deleteAccountActiveSub: "You have an active paid subscription. Cancel it first so you're not billed again, then delete your account.",
    deleteAccountAdmin: "Admin accounts can't be deleted from the app.",
    pauseFrozenResume: 'Payment frozen — resume to reactivate Pro',
    pauseFrozenActiveUntil: 'Payment frozen — Pro active until {date}',
    pauseFrozenExpires: 'Payment frozen — Pro expires, resumes {date}',
    pauseFrozenActiveResumes: 'Payment frozen — Pro active until {date}, resumes {resumeDate}',
    yearlyActive: 'Yearly — Active',
    monthlyActive: 'Monthly — Active',
    tripPassActive: 'Trip Pass — Active',
    tripPassExpired: 'Trip Pass — expired',
    tripPassDaysLeft: 'Trip Pass — {count} day{s} left',
    yearlyRenews: 'Yearly — renews {date}',
    monthlyRenews: 'Monthly — renews {date}',
    tipConcierge: 'Tip the Concierge',
    tipConciergeDescription: 'Had a good time out? A tip helps us keep going...',
    tipButton: 'Tip',
    tripPassLastDay: 'Trip Pass — last day!',
    proPaused: 'Pro Paused',
    proEnabled: 'Pro Enabled',
    proSubtitleFree: 'Unlimited searches, saves, credits & AI',
    upsellFromTripPass: 'Save with a subscription for unlimited credits on every trip',
    upsellFromMonthly: 'Switch to Yearly and save over 50%',
  },

  auth: {
    welcomeBack: 'Welcome Back',
    createAccount: 'Create Account',
    signInDescription: 'Sign in to save and access your trips across devices',
    iHaveAccount: 'I have an account',
    imNewHere: "I'm new here",
    emailPlaceholder: 'you@example.com',
    passwordPlaceholder: 'Enter your password',
    passwordMinChars: 'At least 6 characters',
    confirmPasswordPlaceholder: 'Enter password again',
    pleaseEnterEmail: 'Please enter your email',
    pleaseEnterPassword: 'Please enter your password',
    passwordTooShort: 'Password must be at least 6 characters',
    passwordsDoNotMatch: 'Passwords do not match',
    signingIn: 'Signing in...',
    creatingAccount: 'Creating account...',
    newHere: 'New here?',
    createAnAccount: 'Create an account',
    alreadyHaveAccount: 'Already have an account?',
    installWebApp: 'Install Web App',
    somethingWentWrong: 'Something went wrong',
    apiCostNote: "TripBoom uses premium APIs to find your perfect places — it's free to use, but please consider going Pro to help with our running and API costs.",
    emailSignInLink: 'Email me a sign-in link',
    emailSignInLinkInstead: 'Email me a sign-in link instead',
    signInLinkTitle: 'Sign-in link',
    signInLinkDescription: "Enter your email and we'll send you a one-tap sign-in link. No password needed.",
    sendSignInLink: 'Send sign-in link',
    checkYourEmail: 'Check your email',
    signInLinkSentBody: "Tap the sign-in link in your email to finish. The link works in any browser, including this one. Check spam if you don't see it.",
    signInLinkOrCodeBody: "Tap the link in the email, or type the code from it below. Using the installed TripBoom app? Use the code: links open in your browser instead. Check spam if you don't see it.",
    signInCodeLabel: "Sign-in code",
    signInWithCode: "Sign in with code",
    checkingCode: "Checking…",
    enterCodeFromEmail: "Type the code from the email.",
    codeInvalid: "That code didn't work. It may have expired or already been used; send a new one.",
    forgotPassword: 'Forgot password?',
    resetPassword: 'Reset password',
    emailSent: 'Email sent',
    resetDescription: "Enter your email and we'll send you a link to reset your password.",
    sending: 'Sending...',
    sendResetLink: 'Send reset link',
    resetLinkSent: 'Reset link sent',
    checkEmailForReset: "Check your email for a password reset link. Check spam if you don't see it.",
    done: 'Done',
    continueWithGoogle: 'Continue with Google',
    googleSignInFailed: 'Google sign-in failed',
    or: 'or',
    migrationNotice: 'Beta users who registered before {date} will need to create a new account — sorry for the inconvenience!',
  },

  savedTrips: {
    title: 'Saved Trips',
    tripSaved: 'Trip Saved!',
    noSavedTrips: 'No saved trips yet',
    selectPlacesPrompt: 'Select places and save your trip to see them here',
    backToAllTrips: 'Back to all trips',
    backToPlanning: 'Planning',
    newSearch: 'New Search',
    mergeTrips: 'Merge Trips',
    selectTrips: 'Select Trips',
    merge: 'Merge',
    showAllTrips: 'Show all trips',
    places: 'places',
    deleteGroup: 'Delete group',
    deleteGroupConfirm: 'Delete all trips in this group?',
    groupLimitReached: 'You have reached the free limit. Delete a group or upgrade to save more trips.',
    trips: 'trips',
    addToTrip: 'Add to Trip',
    newSuggestions: 'New suggestions - select to add to your trip',
  },

  itinerary: {
    title: 'Your Itinerary',
  },

  resetPassword: {
    verifying: 'Verifying your reset link...',
    linkExpired: 'Link expired or invalid',
    linkExpiredBody: 'Password reset links expire after 1 hour. Request a new one from the sign-in screen.',
    backToTripBoom: 'Back to TripBoom',
    updated: 'Password updated!',
    updatedBody: "You're now signed in with your new password.",
    goToTripBoom: 'Go to TripBoom',
    setNew: 'Set a new password',
    setNewBody: 'Choose something strong — at least 6 characters.',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    atLeast6: 'At least 6 characters',
    repeatPassword: 'Repeat password',
    saving: 'Saving...',
    submit: 'Set new password',
    tooShort: 'Password must be at least 6 characters',
    mismatch: 'Passwords do not match',
  },

  errors: {
    noOpenPlacesFound: 'No open places found. {count} places are currently closed.',
    noPlacesFound: 'No places found matching your criteria. Try adjusting your search.',
    searchUnavailable: "We couldn't reach our search service just now. Nothing was wrong with your search; please try again in a moment.",
    unableToRank: 'Unable to rank places. Please try again.',
    genericError: 'Error: {message}. Please try again or adjust your search criteria.',
    locationNotFound: 'Could not find that location. Please check the spelling and try again.',
    signInForInterest: 'Sign in to unlock more "Interested in..." searches. It\'s free!',
    creditsExhaustedBody: "You've used your interest search credits for this month — nice exploring! Earn more by sharing in the app, or get Pro for unlimited.",
    dismiss: 'Dismiss',
    goPro: 'Go Pro',
  },

  payment: {
    upgradeFailed: "That didn't go through. Nothing was charged; please try again.",
    unlockUnlimited: 'Unlock Unlimited Trips & Credits',
    upgradeDescription: 'Save as many trips as you want, organized your way',
    limitReached: 'Group Limit Reached',
    dayLimitReached: 'You have {current} of {max} day groups',
    locationLimitReached: 'You have {current} of {max} location groups',
    bothLimitsReached: 'You have {maxDays} day groups and {maxLocations} location groups',
    whatYouGet: 'What you get',
    aiHighMode: 'AI High — extra passes & deeper taste matching',
    unlimitedDayGroups: 'Unlimited day groups',
    unlimitedLocationGroups: 'Unlimited location groups',
    saveUnlimitedTrips: 'Save unlimited trips forever',
    monthly: 'Monthly',
    billedMonthly: 'Billed monthly — cancel any time in the app',
    yearly: 'Yearly',
    billedAnnually: 'Billed annually — cancel any time in the app',
    perMonth: '/month',
    perYear: '/year',
    bestValue: 'BEST VALUE',
    tripPass: 'Trip Pass',
    tripPassDescription: '7 days of Pro — buy when you travel',
    oneOff: 'one-off',
    whyWeCharge: 'Google charges us, every time we use the basic data that\'s free in Maps. We add AI, Taste Learning, Practicality prioritisation, and more. We can only hold Google data for a few days. Sharing this app with others, and your financial support, keeps us running. And we think that\'s cool.',
    upgradeNow: 'Upgrade Now',
    processing: 'Processing...',
    customTip: 'Tip the Concierge',
    customTipDescription: 'A donation to help us build more',
    tipNow: 'Enter amount above',
    thankYou: 'Thank you so much!',
    securePayment: 'Secure checkout',
    upgradeSuccess: 'Welcome to TripBoom Pro!',
    premiumFeature: 'Pro',
    whyWeChargeTitle: 'Why does TripBoom have a Pro tier?',
    billedAnnuallyNeutral: 'Best for frequent travellers',
    billedMonthlyNeutral: 'Flexible — cancel any time',
    betaBannerTitle: 'Beta Access — All Pro features are free',
    betaBannerBody: 'You will not be charged. Activate to unlock everything.',
    activateFreeBeta: 'Activate Free Beta',
    betaActivate: 'Activates instantly — no payment required',
  },
  categories: {
    restaurant: 'restaurant',
    cafe: 'cafe',
    bakery: 'bakery',
    bar: 'bar',
    meal_takeaway: 'meal takeaway',
    meal_delivery: 'meal delivery',
    fast_food_restaurant: 'fast food restaurant',
    coffee_shop: 'coffee shop',
    tourist_attraction: 'tourist attraction',
    museum: 'museum',
    art_gallery: 'art gallery',
    church: 'church',
    hindu_temple: 'hindu temple',
    mosque: 'mosque',
    synagogue: 'synagogue',
    park: 'park',
    amusement_park: 'amusement park',
    aquarium: 'aquarium',
    zoo: 'zoo',
    performing_arts_theater: 'performing arts theater',
    cultural_center: 'cultural center',
    national_park: 'national park',
    campground: 'campground',
    hiking_area: 'hiking area',
    marina: 'marina',
    sports_club: 'sports club',
    sports_complex: 'sports complex',
    stadium: 'stadium',
    ski_resort: 'ski resort',
    athletic_field: 'athletic field',
    bowling_alley: 'bowling alley',
    book_store: 'book store',
    night_club: 'night club',
    liquor_store: 'liquor store',
    market: 'market',
    shopping_mall: 'shopping mall',
    casino: 'casino',
    spa: 'spa',
    movie_theater: 'movie theater',
  },

  referral: {
    friendShared: 'A friend shared TripBoom with you!',
    signUpNudge: 'Sign in to unlock your free searches — and earn your friend bonus credits.',
    signUpFree: 'Sign in free',
    maybeLater: 'Maybe later',
    totalsLine: '{count} friends joined · +{interest} Interest · +{deep} Deep',
    recentJoinersAria: 'Show recent joiners',
  },

  pin: {
    pinAria: 'Add this trip to your plan',
    unpinAria: 'Remove this trip from your plan',
    pinPlanLabel: 'Pin to Plan',
    pinTripToPlanLabel: 'Pin to Plan',
    pinnedLabel: 'Pinned',
    yourPlanLabel: 'Your plan',
    emptyHint: 'Open any saved trip and tap "Pin to Plan" to mark it as your active plan. You can keep up to two pinned at once.',
    emptyHintAria: 'How to pin a trip',
    mergePlan: 'Merge Plan',
    mergePlanAria: 'Merge your two pinned trips into one plan',
  },

  toasts: {
    welcome: 'Welcome to TripBoom! Start exploring',
    firstShare: 'Your first shared trip!',
    firstSaveBonus: 'Welcome! +5 interest searches & 3 AI High searches unlocked',
    saveFailed: "We couldn't save that trip. Please try again.",
    renamed: 'Trip renamed.',
    linkCopied: 'Link copied.',
    deleteFailed: "We couldn't delete that. Please try again.",
    renameFailed: "We couldn't rename that trip. Please try again.",
    addPlacesFailed: "We couldn't add those places. Please try again.",
    loadFailed: "We couldn't load your trips. Showing what we had.",
    cancelDone: 'Subscription cancelled.',
    cancelFailed: "We couldn't cancel your subscription. Please try again.",
    pauseFailed: "We couldn't pause your subscription. Please try again.",
    resumeFailed: "We couldn't resume your subscription. Please try again.",
    refundFailed: 'No matches here, and the credit refund failed. Please contact support.',
    interestCreditRefunded: "That search didn't find anything, so your interest credit is back.",
    subscriptionExpiredTitle: 'Your subscription has ended',
    subscriptionExpiredBody: 'Subscribe again to unlock unlimited searches, saves, and AI features.',
    subscriptionExpiredCTA: 'View plans',
    dismiss: 'Dismiss',
    referralReward: 'Your friend earned +{interest} interest searches & {deep} AI High searches!',
    noAiHighCredits: 'No AI High credits — switched to Medium',
    aiHighLeft: 'AI High ({count} left)',
  },

  reevaluate: {
    headerButton: 'Tune',
    heroBannerTitle: 'Tune these places for your context',
    heroBannerSubtitle: 'Re-rank for where you are now, how you’re getting around, and how long you have',
    heroBannerCta: 'Tune these places for your context',
    title: 'Tune these places',
    langLabel: 'Lang:',
    subtitle: 'Re-rank these places for your context — where you are now, how you’re getting around, and how long you have.',
    locationLabel: 'Location',
    locationOriginal: 'Original',
    locationCurrent: 'Current',
    submitButton: 'Tune',
    reevaluating: 'Tuning…',
    bannerTitle: 'Tuned for you',
    bannerSubtitle: 'Re-ranked based on your context: {transport}, {time}.',
    offlineBannerTitle: 'AI unavailable',
    offlineBannerSubtitle: "Ranked by rating, distance and opening hours for: {transport}, {time}.",
    clear: 'Reset',
    saveCta: 'Save this trip to my account',
    currentLocationLabel: 'Your current location',
    noCoordinatesError: 'This trip has no location data — try Current location instead.',
    geoUnsupportedError: 'Your browser does not support location services.',
    geoPermissionError: 'Location permission denied. Pick Original instead.',
    geoFailedError: 'Could not get your location. Pick Original instead.',
    genericError: 'Tuning failed. Please try again.',
    toastSaved: 'Trip saved! Pin it manually if you want it featured.',
    toastSavedAndPinned: 'Trip saved and pinned to your plan!',
    savedTripButtonLabel: 'Tune',
    savedTripButtonTitle: 'Tune',
    savedTripButtonAria: 'Tune this trip for a new context',
    savedTripBannerTitle: 'Tuned',
    savedTripSave: 'Save as new trip',
    savedTripSaveAria: 'Save this tuned trip as a new trip',
    savedTripDiscard: 'Discard',
    savedTripDiscardAria: 'Discard the tuning and revert to the original order',
  },

  sharedTrip: {
    loadingTrip: 'Loading trip...',
    tripNotFound: 'Trip not found',
    tripNotFoundDesc: 'This trip may have been removed or the link is incorrect.',
    loadFailed: "We couldn't load this trip",
    loadFailedDesc: 'Something went wrong while loading it. The trip may still be there, so please try again.',
    retry: 'Try again',
    placesCount: '{count} places · Tap any place to explore',
    ctaButton: 'Try TripBoom — it\'s free',
    madeWith: 'Made with TripBoom, your AI travel concierge',
    aboutTagline: 'Your AI travel concierge. Tell it what you\'re in the mood for.',
    featureSearch: 'Vibe Search',
    featureSearchDesc: 'Search by mood, not keywords',
    featureAI: 'AI Ranked',
    featureAIDesc: 'Results tailored to what you actually like',
    featureSave: 'Save & Share',
    featureSaveDesc: 'Build trips and share them like this one',
    featureFree: 'Free to Use',
    featureFreeDesc: 'No account needed to start exploring',
    linkFeatures: 'Features',
    linkPricing: 'Pricing',
    linkInstall: 'Install',
  },
};

export type Translations = typeof en;
